import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_PERFORMANCE_REPORT } from './api/query'
import { Data, Variables } from './api/types'
import { PerformanceReport, UseGetPerformanceReport, UseGetPerformanceReportProps } from './types'

export const useGetPerformanceReport = ({
  workspaceId: id,
}: UseGetPerformanceReportProps): UseGetPerformanceReport => {
  const [performanceReport, setPerformanceReport] = useState<PerformanceReport | undefined>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node: performanceReport } = data

      if (performanceReport) {
        setPerformanceReport(fromDTO(performanceReport))
      }
    },
    query: GET_PERFORMANCE_REPORT,
    variables: { id },
  })

  return { loading, performanceReport }
}
